module.exports = "/_next/static/images/sign-up-bg-6a71c38132af3e4714e3ac1b9b3f4881.png";